import { useEffect, useMemo, useState } from "react";
import { firebaseDatabase } from "@/services/firebaseService";
import { ref, onValue } from "firebase/database";
import semver from "semver";
import * as Application from "expo-application";
import { Platform } from "react-native";

type Configs = {
  maintaining: boolean;
  minVersion?: string;
};

const useRemoteConfig = () => {
  const [configs, setConfigs] = useState<Configs>({
    maintaining: false,
  });
  useEffect(() => {
    const maintainingRef = ref(firebaseDatabase, "configs");
    const unsub = onValue(maintainingRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setConfigs(data);
      }
    });
    return () => unsub();
  }, []);

  const requireUpdate = useMemo(() => {
    if (__DEV__) return false;
    const isWeb = Platform.OS === "web";
    const minVersion = configs.minVersion;
    if (!minVersion || isWeb) return false;
    const currentVersion = Application.nativeApplicationVersion ?? "0.0.1";
    return semver.lt(currentVersion, minVersion);
  }, [configs.minVersion]);

  return { ...configs, requireUpdate };
};

export default useRemoteConfig;
